import { render, staticRenderFns } from "./role-list.vue?vue&type=template&id=cf3ef902&scoped=true"
import script from "./role-list.vue?vue&type=script&lang=js"
export * from "./role-list.vue?vue&type=script&lang=js"
import style0 from "./role-list.vue?vue&type=style&index=0&id=cf3ef902&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf3ef902",
  null
  
)

export default component.exports